export { default as List } from 'providers/containers/ProvidersListContainer';
export { default as Form } from 'providers/containers/ProviderFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/containers/index.js